<app-card-template [config]="cardConfig">
  <div class="auction-cut-bid-content">
    <form [formGroup]="cutBidForm" class="auction-cut-bid-form">
      <div class="form-row">
        <div class="input-group">
          <input 
            type="number" 
            formControlName="amount"
            placeholder="Ingrese el valor"
            class="form-input"
            (keyup.enter)="onCutBid()"
            [appRestrictNumberDecimals]="!allowsDecimal"
            [disabled]="!isCutEnabled">
        </div>
        
        <div class="button-group">
          <app-action-loader #cutLoader>
            <button 
              type="button" 
              mat-raised-button
              color="primary"
              (click)="onCutBid()"
              [disabled]="!cutBidForm.valid || cutLoader.isRunning || !isCutEnabled"
              tabindex="0">
              Partir
            </button>
          </app-action-loader>
        </div>
      </div>

      <div class="values-display">
        <div class="value-item">
          <span class="value-label">Valor actual:</span>
          <span class="value-amount">$ {{ currentValue | number:moneyNumberFormat }}</span>
        </div>
        
        <div class="value-item">
          <span class="value-label">Valor al partir:</span>
          <span class="value-amount">$ {{ calculatedValue | number:moneyNumberFormat }}</span>
        </div>
      </div>
    </form>
  </div>
</app-card-template>
